/*
 * Created by Joseph.Saliba on 4/6/15.
 */
import { Factory } from '../../services/Factory';
import { IMonitorable } from '../../model/monitoring/IMonitorable';

export interface IProgressScope extends angular.IScope {
  totalPercentageComplete: () => number;
  isLoggedIn: boolean;
  tasks: IMonitorable[];
}

export class Progress implements angular.IDirective {
  public restrict: string = 'EAC';
  public templateUrl: string;
  public scope = {ngModel: '='};
  public link: (scope: angular.IScope) => void;

  /*
   * Percentage for an already-tracked task. Monitorables carry either a job percentage
   * (exports, tagging, search terms) or processed/queued counts (collections), and a
   * collection reports counts of 0/0 while it is still initializing. The previous
   * unguarded `Math.max(pct, Math.floor(numProcessed / numQueued * 100))` turned into
   * NaN for anything without counts and for any 0/0 collection, and because the NaN was
   * written back to the task it poisoned every later update — the bar rendered at
   * `width: NaN%` (i.e. nothing) for the rest of the session.
   */
  public static resolvePercentage(item: any, task: IMonitorable): number {
    const candidates: number[] = [];

    const reported = item.job && item.job.percentageComplete;
    if (typeof reported === 'number' && isFinite(reported)) {
      candidates.push(reported);
    }

    if (item.numQueued > 0 && isFinite(item.numProcessed)) {
      candidates.push(Math.floor(item.numProcessed / item.numQueued * 100));
    }

    if (!candidates.length) {
      const current = task.job && task.job.percentageComplete;
      return typeof current === 'number' && isFinite(current) ? current : 0;
    }

    return Math.max(0, Math.max.apply(null, candidates));
  }

  constructor(stateService: app.services.state.StateService) {
    this.templateUrl = 'partials/progress.html';
    this.link = (scope: IProgressScope) => {

      scope.totalPercentageComplete = (): number => {
        if (!scope.tasks) {
          return 0;
        }

        let total: number = 0;
        let counted: number = 0;

        angular.forEach(scope.tasks, (item: IMonitorable) => {
          const percent = item.job && item.job.percentageComplete;
          if (typeof percent === 'number' && isFinite(percent)) {
            total += percent;
            ++counted;
          }
        });

        return counted ? total / counted : 0;
      };

      scope.isLoggedIn = !stateService.IsLoggedOut();

      scope.$on(EVENTS.LOGIN_CONFIRMED, () => {
        scope.isLoggedIn = true;
      });

      scope.$on(EVENTS.LOGIN_REQUIRED, () => {
        scope.isLoggedIn = false;
      });

      scope.$on('MonitorableUpdated', (e: any, item: IMonitorable) => {
        if (!scope.tasks) {
          scope.tasks = [];
        }

        let task: IMonitorable = _.findWhere(scope.tasks, {id: item.id});
        if (!task) {
          scope.tasks.push(item);
          scope.$applyAsync();
        } else {
          task.job.percentageComplete = Progress.resolvePercentage(item, task);
          scope.$applyAsync();
        }
      });

      scope.$on('MonitorableCompleted', (e: any, item: IMonitorable) => {
        scope.tasks = _.without(scope.tasks, _.findWhere(scope.tasks, {id: item.id}));
      });
    }
  }
}

frontendApp.directive("iioProgress", ['StateService', Factory.Create(Progress)]);
